import type { Role } from "./searchUtils";

interface Named {
  name: string;
}

function sortByName<T extends Named>(array: T[]): T[] {
  return array.sort((a, b) => {
    const al = a.name.toLowerCase();
    const bl = b.name.toLowerCase();
    return al < bl ? -1 : al > bl ? 1 : 0;
  });
}

interface ParsedNodeId {
  roleId?: number;
  positionId?: number;
  operationId?: number;
  aircraftTypeId?: number;
}

const RelationTreeService = {
  getRelationFromNodeId(nodeId: string): ParsedNodeId {
    const route = nodeId.split("/");
    const relation: ParsedNodeId = {};
    for (const v of route) {
      if (/^rol/.test(v)) relation.roleId = +v.replace("rol", "");
      if (/^a/.test(v)) relation.aircraftTypeId = +v.replace("a", "");
      if (/^p/.test(v)) relation.positionId = +v.replace("p", "");
      if (/^o/.test(v)) relation.operationId = +v.replace("o", "");
    }
    return relation;
  },

  sortRelations(relations: Role[]): Role[] {
    const sorted = sortByName(relations);
    sorted.forEach((rel) => {
      rel.courses = sortByName(rel.courses ?? []);
      rel.customCourses = sortByName(rel.customCourses ?? []);
      rel.groups = sortByName(rel.groups ?? []);
      rel.positions?.forEach((position) => {
        position.courses = sortByName(position.courses ?? []);
        position.customCourses = sortByName(position.customCourses ?? []);
        position.groups = sortByName(position.groups ?? []);
      });
    });
    return sorted;
  },
};

export type { ParsedNodeId };
export default RelationTreeService;
